export default "__VITE_ASSET__Dxd6ZdIG__"